import type { ReactElement } from 'react';
import React from 'react';

import type { TagLabelProps, SizeTypes, PaletteTypes } from './TagLabel.types';
import { TagLabelPalette, TagLabelSize } from './TagLabel.types';
import { Box } from './subcomponents/Box';
import { TextParent } from './subcomponents/TextParent';

export const TagLabel = (props: TagLabelProps): ReactElement => {
  const {
    palette = TagLabelPalette.primary as PaletteTypes,
    size = TagLabelSize.medium as SizeTypes,
    children,
    testID = 'sg-tag-label',
    ...rest
  } = props;

  return (
    <Box palette={palette} size={size} testID={testID}>
      <TextParent
        palette={palette}
        size={size}
        {...rest}
        testID={`${testID}-text`}
      >
        {children}
      </TextParent>
    </Box>
  );
};
